import { render, staticRenderFns } from "./EditDiscountModule.vue?vue&type=template&id=31770955&"
import script from "./EditDiscountModule.vue?vue&type=script&lang=js&"
export * from "./EditDiscountModule.vue?vue&type=script&lang=js&"
import style0 from "./EditDiscountModule.vue?vue&type=style&index=0&id=31770955&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports